// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getActionsByRoleAndStatus(role, status) {
  switch (role.TAG | 0) {
    case /* BusinessAdmin */0 :
        switch (status) {
          case /* Deactivated */0 :
              return /* [] */0;
          case /* Pending */1 :
              return {
                      hd: /* Approve */2,
                      tl: {
                        hd: /* Discard */3,
                        tl: /* [] */0
                      }
                    };
          case /* Scheduled */2 :
              return {
                      hd: /* Delete */1,
                      tl: /* [] */0
                    };
          case /* Active */3 :
              return {
                      hd: /* Deactivate */0,
                      tl: /* [] */0
                    };
          
        }
    case /* CityAdmin */1 :
    case /* User */2 :
        return /* [] */0;
    
  }
}

function deactivateBeforeTomorrowCheck(status, end_date) {
  if (status >= 3 && end_date !== undefined) {
    return Timestamp$Catalyst.isBefore(Caml_option.valFromOption(end_date), Timestamp$Catalyst.tomorrow(undefined));
  } else {
    return false;
  }
}

function areActionsAllowed(role, is_prioritised, is_core_pricing_pending, action_taken, status, end_date) {
  switch (role.TAG | 0) {
    case /* BusinessAdmin */0 :
        return !(is_prioritised || is_core_pricing_pending || Belt_Option.isSome(action_taken) || deactivateBeforeTomorrowCheck(status, end_date) || status === /* Deactivated */0);
    case /* CityAdmin */1 :
    case /* User */2 :
        return false;
    
  }
}

export {
  getActionsByRoleAndStatus ,
  deactivateBeforeTomorrowCheck ,
  areActionsAllowed ,
  
}
/* Timestamp-Catalyst Not a pure module */
